<template>
    <div
        class="expense__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid border-white"
    >
        <div class="flex w-1/3 justify-start content content-center">
            <slot name="left"></slot>
        </div>
        <div class="flex w-1/3 justify-end content content-center">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'action-bar'
}
</script>

<style scoped>
.content {
    height: 28px !important;
}
</style>
